module.exports = __webpack_public_path__ + "static/img/JD-logo.dfdb09e1.png";